import { render, staticRenderFns } from "./NonGeoPicklItem.vue?vue&type=template&id=33228c06&scoped=true&"
import script from "./NonGeoPicklItem.vue?vue&type=script&lang=ts&"
export * from "./NonGeoPicklItem.vue?vue&type=script&lang=ts&"
import style0 from "./NonGeoPicklItem.vue?vue&type=style&index=0&id=33228c06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33228c06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33228c06')) {
      api.createRecord('33228c06', component.options)
    } else {
      api.reload('33228c06', component.options)
    }
    module.hot.accept("./NonGeoPicklItem.vue?vue&type=template&id=33228c06&scoped=true&", function () {
      api.rerender('33228c06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/NonGeoPicklItem.vue"
export default component.exports